import styled from 'styled-components';
import { lightGrey2Color } from 'js/config/style';

export default styled.div`
  color: ${lightGrey2Color};
  text-align: right;
`;
